import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  makeStyles,
  BlockIcon,
  Switch,
  Stack,
  Typography,
  CheckCircleIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import Status from 'scenes/CustomAudiences/PartnerAudiences/components/Status';
import { ACTION_SYNC } from 'scenes/CustomAudiences/PartnerAudiences/constants';
import { useAutoSyncPA } from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

const useStyles = makeStyles(() => ({
  switch: {
    marginLeft: '-12px',
  },
}));

const MetaData = ({ data }) => {
  const classes = useStyles();
  const [toggleAutosync] = useAutoSyncPA();

  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        type={({ value: { id, name } }) => {
          return <Status id={id}>{name}</Status>;
        }}
        field={'filterStatus'}
      />
      <DescriptionItem
        label={'Parent Audience auto sync'}
        value={data}
        type={({ value }) => {
          return value?.parentAudience?.autoSync ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CheckCircleIcon sx={{ fontSize: 16 }} color={'success'} />
              <Typography>On</Typography>
            </Stack>
          ) : (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <BlockIcon sx={{ fontSize: 16 }} color={'inactive'} />
              <Typography>Off</Typography>
            </Stack>
          );
        }}
      />
      <DescriptionItem
        label={'Auto sync'}
        value={data}
        type={({ value }) => {
          return (
            <Permissions actions={data.actions}>
              {({ isActionAllowed }) => {
                return (
                  <Switch
                    className={classes.switch}
                    checked={value.autoSync}
                    disabled={!isActionAllowed(ACTION_SYNC)}
                    onChange={() => toggleAutosync({ id: value.id })}
                  />
                );
              }}
            </Permissions>
          );
        }}
      />
      <DescriptionItem
        label={'Last sync'}
        type={'metadata'}
        value={data}
        dateField={'lastSyncDate'}
      />
      <DescriptionItem label={'Owner'} field={'owner.name'} />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        value={data}
        userField={'createdBy.name'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default MetaData;
